export const LOGIN = 'USER/LOGIN';
export const LOGOUT = 'USER/LOGOUT';
export const UPDATE_USER = 'USER/UPDATE_USER';
export const UPDATE_PERSIST_ACCOUNT = 'USER/UPDATE_PERSIST_ACCOUNT';
